<template>
  <Component
    :is="tag"
    :class="classes"
    :data-grade="grade"
  >
    <div class="answer__body">
      <slot>
        <template v-if="isRankingType">
          <span class="answer__index">{{ index + 1 }}</span>
          <p class="answer__text bvi-speech">
            {{ answer.answer }}
          </p>
        </template>

        <p
          v-else
          class="answer__text bvi-speech"
        >
          {{ answer.answer }}
        </p>
      </slot>
    </div>

    <UComment
      v-if="isRevealed && answer.comments"
      class="mt-1 bvi-speech"
    >
      <MarkdownContent :content="answer.comments" />
    </UComment>
  </Component>
</template>

<script>
import UComment from '@components/UComment.vue'
import MarkdownContent from '@/components/MarkdownContent.vue'

export default {
  name: 'TrainingQuizAnswer',

  components: {
    UComment,
    MarkdownContent
  },

  props: {
    value: {
      type: Object,
      default: () => ({})
    },

    answer: {
      type: Object,
      required: true
    },

    index: {
      type: Number,
      default: 0
    },

    isRevealed: {
      type: Boolean,
      default: false
    },

    isReadonly: {
      type: Boolean,
      default: false
    },

    isShowCorrectAnswer: {
      type: Boolean,
      default: false
    },

    tag: {
      type: String,
      default: 'div'
    },

    isSimpleType: {
      type: Boolean,
      default: false
    },

    isRankingType: {
      type: Boolean,
      default: false
    },

    isMappingType: {
      type: Boolean,
      default: false
    }
  },

  computed: {
    grade () {
      const MAX_GRADE_VALUE = 100
      const MIN_GRADE_VALUE = 0

      if (!this.isRevealed) {
        return
      }

      if (this.isRankingType) {
        const isCorrect = this.isReadonly ? this.answer.settings.isCorrect : ((this.index + 1) === parseInt(this.answer.settings.key))
        return isCorrect ? MAX_GRADE_VALUE : MIN_GRADE_VALUE
      }

      if (this.isMappingType) {
        const isCorrect = this.isReadonly ? this.answer.settings.isCorrect : (this.answer.settings.value === this.value.answer_value)
        return isCorrect ? MAX_GRADE_VALUE : MIN_GRADE_VALUE
      }

      return Math.max(parseInt(this.answer.grade), MIN_GRADE_VALUE)
    },

    classes () {
      return {
        answer: true,
        'answer--type-simple': this.isSimpleType,
        'answer--type-ranking': this.isRankingType,
        'answer--type-mapping': this.isMappingType,
        'answer--selected': this.answer.isSelected,
        'answer--revealed': this.isRevealed,
        'answer--readonly': this.isReadonly
      }
    }
  }
}
</script>

<style lang="scss">
  .answer {
    border-radius: $border-radius-root;
    padding: 0;
    margin: 0;

    .v-label {
      user-select: inherit;
    }
  }

  .answer--type-ranking:not(.answer--readonly) {
    margin: 0.5rem 0;
    border: $border;
    cursor: move;

    .answer__text {
      padding: 0.5rem 0;
    }
  }

  .answer--type-mapping:not(.answer--readonly) {
    margin: 0.5rem 0;
  }

  .answer--readonly {
    padding: 0.5rem;
    margin: 0.25rem 0;
  }

  .answer--selected.answer--readonly:not(.answer--type-ranking):not(.answer--type-mapping) {
    background-color: rgba(black, 0.06);
  }

  .answer--revealed {
    &[data-grade],
    &[data-grade] .v-label {
      color: var(--v-warning-base);
    }

    &[data-grade="0"],
    &[data-grade^="-"],
    &[data-grade="0"] .v-label,
    &[data-grade^="-"] .v-label {
      color: var(--v-error-base);
    }

    &[data-grade="100"],
    &[data-grade="100"] .v-label {
      color: var(--v-success-base);
    }
  }

  .answer__body {
    display: flex;
    gap: 1rem;
    position: relative;
    padding: 0;
  }

  .answer__text.answer__text {
    margin: 0;
  }

  .answer__index {
    display: flex;
    align-items: center;
    padding: 0.5rem 1rem;
    background-color: rgba(black, 0.12);
    font-weight: 600;
  }
</style>
